import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip } from 'antd';
import { actions as newRequestActions } from '../../../containers/CreateRequest/new-request.actions';
import addressActions from '../../../actions/address.actions';
import serviceActions from '../../../actions/service.actions';
import CellDataContainer from '../CellDataContainer/CellDataContainer';
import CellText from '../CellText/CellText';

const RequestParentServiceAndService = ({
  request = {},
  getPopupContainer = () => document.body,
  canChange = true,
}) => {
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.authentication.userInfo);

  const parentService = request.parentService || '-';
  const service = request.service || '-';

  const isActive =
    canChange && !request.paidServiceRequestId && userInfo.CanChangeServiceType;

  const handleParentServiceClick = (e) => {
    e.stopPropagation();
    dispatch(newRequestActions.setRequestId(request.id));
    dispatch(newRequestActions.applyAddrStreet(request.streetId));
    dispatch(
      newRequestActions.applyAddrBuilding(request.houseId, request.serviceId)
    );
    dispatch(newRequestActions.setAddrFlatValue(request.addressId));
    dispatch(newRequestActions.setSubserviceValue(request.serviceId));
    dispatch(newRequestActions.applyService(request.parentServiceId));
    dispatch(newRequestActions.applyPossWarranty(request.garantyId > 0));
    dispatch(
      newRequestActions.setWorkerValue(request.master && request.master.id)
    );
    dispatch(
      newRequestActions.setExecuterValue(
        request.executer && request.executer.id
      )
    );
    dispatch(
      addressActions.openAddressModal({ ...request, serviceOnly: true })
    );
  };

  const handleServiceClick = (e) => {
    e.stopPropagation();
    dispatch(
      serviceActions.openServiceModal(
        `${request.id}`,
        `${request.parentService}`,
        `${request.parentServiceId}`,
        `${request.serviceId}`,
        `${request.houseId}`
      )
    );
  };

  const contentArr = [
    {
      key: 'parentService',
      tooltipTitle: isActive ? 'Изменить услугу' : 'Услуга',
      getPopupContainer,
      onClick: isActive ? handleParentServiceClick : undefined,
      text: parentService,
    },
    {
      key: 'service',
      tooltipTitle: isActive ? 'Изменить причину' : 'Причина',
      getPopupContainer,
      onClick: isActive ? handleServiceClick : undefined,
      text: service,
    },
  ];

  return (
    <CellDataContainer>
      {contentArr.map((content) => (
        <Tooltip
          key={content.key}
          title={content.tooltipTitle}
          getPopupContainer={content.getPopupContainer}
          placement="topLeft"
        >
          <CellText
            onClick={content.onClick}
            style={{ cursor: isActive ? 'pointer' : 'initial' }}
          >
            {content.text}
          </CellText>
        </Tooltip>
      ))}
    </CellDataContainer>
  );
};

export default RequestParentServiceAndService;
